import { Injectable } from '@angular/core';
import { NewCustomerPage } from './new-customer.page';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface CustomerViewModel {
  email: string;
  addToNewsletter: boolean;
  registerCustomer: boolean;
  title: string;
  firstName: string;
  lastName: string;
  company: string;
  tel: string;
  street: string;
  houseNumber: string;
  addressSupplement: string;
  postcode: string;
  place: string;
  country: string;
}

@Injectable({providedIn: 'root'})
export class CustomerService {
  constructor(private readonly modalService: NgbModal) {
  }

  async openNewCustomerModal(): Promise<null | CustomerViewModel> {
    const newCustomerData = await this.modalService.open(NewCustomerPage, {
      size: 'xl'
    }).result.then(result => result, () => false);

    if (!newCustomerData) {
      return null;
    }

    return newCustomerData;
  }
}
